import axios from 'axios';
import authHeader from '../auth-header'
import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/all/";

const getLogKeanggotaan = 'log-keanggotaan';

class LogKeanggotaanService {
    
    getLogKeanggotaan(currentPage, pageSize, search, type, statusLog, source) {

        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            search : search,
            type: type, 
            statusLog: statusLog, 
            source: source
        };
        
        return axios.get(
            API_URL + getLogKeanggotaan ,
        {
            params : data,
            headers: authHeader()
        });
    }

    confirmStatus(id) {
        return axios.get(API_URL + 'confirm-status', {params:{id:id},headers:authHeader()} );
    }

    putStatus(formData) {
        return axios.put(API_URL + 'post-status', formData, {headers:authHeader()} );
    }

    countQuery() {
        return axios.get(API_URL + 'count-item',{headers:authHeader()});
    }

}

export default new LogKeanggotaanService();